import type { SVGProps } from 'react';

const paths: Record<string, string> = {
  home: '<path d="M3 12l9-8 9 8"/><path d="M5 10v10h14V10"/>',
  droplet: '<path d="M12 3s6 6.5 6 11a6 6 0 1 1-12 0c0-4.5 6-11 6-11z"/>',
  'file-text': '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><path d="M14 3v6h6"/><path d="M8 13h8M8 17h5"/>',
  layout: '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18M3 9h18"/>',
  map: '<path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z"/><path d="M9 4v16M15 6v16"/>',
  sparkles: '<path d="M12 3l1.7 4.3L18 9l-4.3 1.7L12 15l-1.7-4.3L6 9l4.3-1.7z"/><path d="M19 16l.7 1.8L21 18.5l-1.3.7L19 21l-.7-1.8L17 18.5l1.3-.7z"/>',
  database: '<ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5"/><path d="M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6"/>',
  cloud: '<path d="M17 18H7a5 5 0 0 1-1-9.9A7 7 0 0 1 19 9a4 4 0 0 1-2 9z"/>',
  users: '<circle cx="9" cy="8" r="3.5"/><path d="M3 20c0-3 2.7-5 6-5s6 2 6 5"/>',
  settings: '<circle cx="12" cy="12" r="3"/><path d="M12 1v6M12 17v6M4.22 4.22l4.24 4.24M15.54 15.54l4.24 4.24M1 12h6M17 12h6M4.22 19.78l4.24-4.24M15.54 8.46l4.24-4.24"/>',
  shield: '<path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/>',
  bell: '<path d="M6 9a6 6 0 0 1 12 0c0 7 3 8 3 8H3s3-1 3-8"/><path d="M10 20a2 2 0 0 0 4 0"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  chevron: '<path d="M9 18l6-6-6-6"/>',
  'chevron-down': '<path d="M6 9l6 6 6-6"/>',
  'chevrons-left': '<path d="M11 17l-5-5 5-5"/><path d="M18 17l-5-5 5-5"/>',
  'chevrons-right': '<path d="M13 17l5-5-5-5"/><path d="M6 17l5-5-5-5"/>',
  pin: '<line x1="12" y1="17" x2="12" y2="22"/><path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"/>',
  filter: '<path d="M4 5h16l-6 8v5l-4 2v-7z"/>',
  download: '<path d="M12 4v12M6 10l6 6 6-6"/><path d="M4 20h16"/>',
  eye: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
  upload: '<path d="M12 20V8M6 14l6-6 6 6"/><path d="M4 4h16"/>',
  check: '<path d="M5 13l4 4L19 7"/>',
  x: '<path d="M6 6l12 12M18 6l-12 12"/>',
  arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
  edit: '<path d="M4 20h4l10-10-4-4L4 16z"/><path d="M14 6l4 4"/>',
  copy: '<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>',
  folder: '<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>',
  more: '<circle cx="5" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="19" cy="12" r="1.5"/>',
  logout: '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/>',
  calendar: '<rect x="3" y="4" width="18" height="17" rx="2"/><path d="M3 9h18M8 2v4M16 2v4"/>',
  truck: '<path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>',
  'id-card': '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="M5.5 16c.4-1.4 1.8-2.2 3.5-2.2s3.1.8 3.5 2.2"/><path d="M15 10h4M15 13h4"/>',

  // ── Ikony menu ─────────────────────────────────────────────────────────
  // Menu boczne ma 40 pozycji, a dzieliło między nie 18 ikon (samo `file-text`
  // powtarzało się 8×, `calendar` 5×) — na zwiniętej szynie pozycje były wtedy
  // nie do odróżnienia. Poniższe ikony domykają zasadę „jedna pozycja menu =
  // jedna ikona”. Ten sam styl co wyżej: siatka 24×24, sam kontur, stroke 1.8.
  core: '<rect x="7" y="3" width="10" height="18" rx="1.5"/><path d="M7 9h10M7 14h10"/>',
  drill: '<path d="M9 3h6v7l-3 4-3-4z"/><path d="M12 14v7"/><path d="M9 21h6"/>',
  clipboard: '<rect x="6" y="4" width="12" height="17" rx="2"/><path d="M9.5 4V2.9h5V4"/><path d="M9 11h6M9 15h4"/>',
  gantt: '<rect x="3" y="5" width="10" height="3" rx="1.5"/><rect x="7" y="10.5" width="12" height="3" rx="1.5"/><rect x="5" y="16" width="8" height="3" rx="1.5"/>',
  mesh: '<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M4 9.3h16M4 14.6h16M9.3 4v16M14.6 4v16"/>',
  'shield-alert': '<path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6z"/><path d="M12 8.5v4"/><path d="M12 16h.01"/>',
  archive: '<rect x="3" y="3" width="18" height="5.5" rx="1.5"/><path d="M4.5 8.5v10a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-10"/><path d="M9.5 13h5"/>',
  kanban: '<rect x="3" y="4" width="5" height="12" rx="1.5"/><rect x="10" y="4" width="5" height="16" rx="1.5"/><rect x="17" y="4" width="4" height="8" rx="1.5"/>',
  alarm: '<circle cx="12" cy="13" r="7"/><path d="M12 10v3.2l2.2 1.6"/><path d="M5.5 4L3.2 6.2M18.5 4l2.3 2.2"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2.4M12 19.6V22M4.4 12H2M22 12h-2.4M6.3 6.3L4.6 4.6M19.4 19.4l-1.7-1.7M6.3 17.7l-1.7 1.7M19.4 4.6l-1.7 1.7"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 6.8V12l3.4 2"/>',
  receipt: '<path d="M5 3h14v18l-2.4-1.4L14.2 21l-2.2-1.4L9.8 21l-2.4-1.4L5 21z"/><path d="M9 8.5h6M9 12.5h6"/>',
  landmark: '<path d="M12 3l9 5H3z"/><path d="M3 10h18"/><path d="M6.5 10v7M10 10v7M14 10v7M17.5 10v7"/><path d="M3 20h18"/>',
  repeat: '<path d="M4 10a6 6 0 0 1 6-6h8"/><path d="M15 1.2L18.2 4 15 6.8"/><path d="M20 14a6 6 0 0 1-6 6H6"/><path d="M9 22.8L5.8 20 9 17.2"/>',
  tag: '<path d="M3 12V4.5A1.5 1.5 0 0 1 4.5 3H12l9 9-7.5 7.5z"/><circle cx="7.6" cy="7.6" r="1.4"/>',
  wand: '<path d="M4 20L15.5 8.5"/><path d="M14 3l1 2.6L17.6 6.6 15 7.6 14 10.2 13 7.6 10.4 6.6 13 5.6z"/><path d="M19 14l.7 1.7 1.8.8-1.8.8-.7 1.7-.7-1.7-1.8-.8 1.8-.8z"/>',
  contract: '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"/><path d="M14 3v6h6"/><path d="M13.5 19.4c1.4-3 2.8-3 4.2 0s2.8 1.4 4.2-.6"/>',
  'map-pin': '<path d="M12 21.5s7-6.4 7-11.3A7 7 0 1 0 5 10.2c0 4.9 7 11.3 7 11.3z"/><circle cx="12" cy="10" r="2.6"/>',
  layers: '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/>',
  'pen-ai': '<path d="M3 21h4L16.5 11.5l-4-4L3 17z"/><path d="M12.5 7.5l4 4"/><path d="M19 3l.8 2.2 2.2.8-2.2.8L19 9l-.8-2.2-2.2-.8 2.2-.8z"/>',
  'chart-bar': '<path d="M4 20V10.5M10 20V4M16 20v-6.5"/><path d="M2.5 20h19"/>',
  'chart-pie': '<path d="M12 3a9 9 0 1 0 9 9h-9z"/><path d="M14.5 3.4A9 9 0 0 1 20.6 9.5H14.5z"/>',
  lock: '<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/><path d="M12 14.5V17"/>',
  history: '<path d="M3.2 12a9 9 0 1 0 2.9-6.6"/><path d="M3 3.5V9h5.5"/><path d="M12 8v4.2l3 1.8"/>',
  'user-shield': '<circle cx="9" cy="7.5" r="3.5"/><path d="M3 20c0-3 2.7-5 6-5h1.5"/><path d="M17.5 12l4 1.5V16c0 2.3-1.7 3.7-4 4.3-2.3-.6-4-2-4-4.3v-2.5z"/>',
  sliders: '<path d="M4 6h9M18.2 6H20M4 12h3.8M12.2 12H20M4 18h11.8M20 18h.01"/><circle cx="16" cy="6" r="2.2"/><circle cx="10" cy="12" r="2.2"/><circle cx="18" cy="18" r="2.2"/>',
  'book-open': '<path d="M12 6.2C10 4.8 7.5 4.2 4 4.2v14c3.5 0 6 .6 8 2 2-1.4 4.5-2 8-2v-14c-3.5 0-6 .6-8 2z"/><path d="M12 6.2v14"/>',
  chip: '<rect x="7" y="7" width="10" height="10" rx="2.5"/><path d="M10 2.5V6M14 2.5V6M10 18v3.5M14 18v3.5M2.5 10H6M2.5 14H6M18 10h3.5M18 14h3.5"/>',
  'chevron-up': '<path d="M6 15l6-6 6 6"/>',
  grip: '<circle cx="9" cy="6" r="1.3"/><circle cx="15" cy="6" r="1.3"/><circle cx="9" cy="12" r="1.3"/><circle cx="15" cy="12" r="1.3"/><circle cx="9" cy="18" r="1.3"/><circle cx="15" cy="18" r="1.3"/>',
};

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: string;
  size?: number;
}

export function Icon({ name, size = 16, className = '', ...rest }: IconProps) {
  const content = paths[name] ?? '';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      dangerouslySetInnerHTML={{ __html: content }}
      {...rest}
    />
  );
}
